import { arrayToMap } from 'lib/array/arrayUtils'

export function getScheduleChangeLegPairs(change: App.FlightScheduleChange) {
  const oldLegs = arrayToMap(change.oldLegs, leg => leg.id)
  const newLegs = arrayToMap(change.newLegs, leg => leg.id)

  // Preserve missing matches as undefined; never substitute an unrelated leg.
  return change.affectedLegs.map(({ oldLegId, newLegId }) => ({
    oldLegId,
    newLegId,
    oldLeg: oldLegs.get(oldLegId),
    newLeg: newLegs.get(newLegId),
  }))
}
